import { useParams } from "react-router-dom"
import { useTournamentDetail } from "@/graphql/hooks/useTournamentDetail"
import { LoadingScreen } from "@/components/ui/loading-spinner"
import { useEffect } from "react"

const TournamentPlayersPrint = () => {
  const { tournamentId } = useParams<{ tournamentId: string }>()
  const { tournament, loading } = useTournamentDetail(Number(tournamentId))

  useEffect(() => {
    if (!loading && tournament) {
      document.title = `Lista de Jugadores - ${tournament.name}`
    }
  }, [loading, tournament])

  if (loading) {
    return <LoadingScreen message="Cargando lista de jugadores..." />
  }

  if (!tournament || !tournament.TournamentPlayers) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-bold">Torneo no encontrado</h2>
      </div>
    )
  }

  // Sort players alphabetically by name
  const sortedPlayers = [...tournament.TournamentPlayers].sort((a, b) =>
    a.Person.fullName.localeCompare(b.Person.fullName),
  )

  return (
    <div className="p-4 bg-white text-black dark:bg-gray-900 dark:text-gray-100 min-h-screen print:bg-white print:text-black">
      <div className="mb-6 text-center">
        <h1 className="text-2xl font-bold mb-2">{tournament.name}</h1>
        <h2 className="text-lg">Lista de Jugadores Inscritos</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
          Total de jugadores: {sortedPlayers.length}
        </p>
      </div>

      <table className="w-full border-collapse border border-black dark:border-gray-600 print:border-black text-sm">
        <thead>
          <tr className="bg-gray-100 dark:bg-gray-700 print:bg-gray-200">
            <th className="border border-black dark:border-gray-600 print:border-black p-2 text-left">
              #
            </th>
            <th className="border border-black dark:border-gray-600 print:border-black p-2 text-left">
              Nombre
            </th>
            <th className="border border-black dark:border-gray-600 print:border-black p-2 text-left">
              Código
            </th>
            <th className="border border-black dark:border-gray-600 print:border-black p-2 text-left">
              Estado
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedPlayers.map((player, index) => (
            <tr
              key={player.id}
              className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-800 dark:even:bg-gray-700 print:odd:bg-white print:even:bg-gray-100"
            >
              <td className="border border-black dark:border-gray-600 print:border-black pl-2">
                {index + 1}
              </td>
              <td className="border border-black dark:border-gray-600 print:border-black pl-2 font-medium">
                {player.Person.fullName}
              </td>
              <td className="border border-black dark:border-gray-600 print:border-black pl-2">
                {player.Person.code}
              </td>
              <td className="border border-black dark:border-gray-600 print:border-black pl-2">
                {player.drop === 1 ? "Drop" : "Activo"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-6 text-xs text-gray-500 dark:text-gray-400 print:text-black">
        <p>Impreso el: {new Date().toLocaleString("es-ES")}</p>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .no-print {
          display: none !important;
        }
      }
    `,
        }}
      />
    </div>
  )
}

export default TournamentPlayersPrint
